document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('[id^="CollectionCarousel-"]')
    .forEach(function (el) {
      new Splide(el, {
        perPage: 4,
        perMove: 1,
        arrows: true,
        pagination: true,
        breakpoints: {
          749: { perPage: 1 },
        },
      }).mount();
    });
  document.querySelectorAll(".banner-carrossel__list").forEach(function (el) {
    new Splide(el, {
      perPage: 4,
      perMove: 2,
      arrows: true,
      pagination: true,
      breakpoints: {
        749: {
          perPage: 1.1,
          perMove: 1,
          arrows: false,
          pagination: false,
          isNavigation: true,
        },
      },
    }).mount();
  });
});
